import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { searchTextState } from '../../redux/categories'

class SearchField extends Component {

  handleOnKeyUp = () => {
    this.props.search(this.refs.searchInput.value)
    this.props.dispatch(searchTextState(this.refs.searchInput.value))
    this.props.callback()
  }

  componentDidMount() {
    if (this.props.categories && this.props.categories.previousSearchText) {
      this.setValue(this.props.categories.previousSearchText)
    } else {
      this.setValue("")
    }
  }

  setValue(value) {
    ReactDOM.findDOMNode(this.refs.searchInput).value = value
    this.props.search(value)
  }

  render() {
    return (
      <input
        ref='searchInput'
        className='form-control'
        type='text'
        defaultValue={this.props.defaultValue}
        placeholder="Enter categories details..."
        onKeyUp={this.handleOnKeyUp} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    categories: state.categories
  }
}

export default connect(mapStateToProps, null, null, { withRef: true })(SearchField)


// WEBPACK FOOTER //
// ./src/modules/Categories/Components/TableCustomComponents/SearchField.js